import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit, Output, Input, Inject } from '@angular/core';
import 'quill-mention';
import 'quill-emoji';

import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';
Quill.register('modules/imageResize', ImageResize);

import { ServerService } from 'src/app/services/server.service';
import {
  MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig,
  MatPaginator
} from '@angular/material';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ActivatedRoute } from '@angular/router';
import { EventEmitter } from 'protractor';


@Component({
  selector: 'app-campaign-comment',
  templateUrl: './campaign-comment.component.html',
  styleUrls: ['./campaign-comment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CampaignCommentComponent implements OnInit {

  //@Output() commentSubmitEvent = new EventEmitter()

  @Input('pCommentData') commentData;
  @Input('pTaskData') taskData;

  @Input('viewMediaDetailRequest') viewMediaDetailRequest;
  // temp = localStorage.setItem('masterComment',"false")
  showComponentLoader: boolean = true;

  authToken = localStorage.getItem('token');

  tableRowData: any;

  moduleType: any = 'Campaign'
  campaignId: any;

  btnStatus: boolean = false;

  quillConfig: any;

  htmlText = ""
  hasFocus = false;
  subject: string;

  salePersonList: any;
  commentSalePersonList: any;
  dataIdsArr: any;

  allComment: any;
  allCommentTypeData:any;

  //selectedCommentCategory:any={ "id": 488, "subject": "Creative & Communication", "task_type": "Creative & Communication", "description": null, "status": "TO DO", "assigned_user_id": 1100, "created_by": 0, "campaign_id": 85, "created_at": "2024-07-22T12:32:52.000+05:30", "updated_at": "2024-07-22T12:32:52.000+05:30", "created_by_user": "system", "assigned_user": { "id": 1100, "name": "satishcreative" }, "title": "Creative & Communication", "parent": "CampaignTask" };
  selectedCommentCategory: any;

  selectedCommentViewCategory: any;

  commentCategory: any = [

    {
      "id": 0,
      "title": "Campaign",
      child: [
        {
          "id": 85,
          "title": "campaign",
          "parent": "Campaign"
        }
      ]
    },

    {
      "id": 1,
      "title": "CampaignTask",
      "child": [
        {
          "id": 488,
          "title": "Creative & Communication",
          "parent": "CampaignTask",
          "subject": "Creative & Communication",
          "task_type": "Creative & Communication",
          "description": null,
          "status": "TODO",
          "assigned_user_id": 1100,
          "created_by": 0,
          "campaign_id": 85,
          "created_at": "2024-07-22T12:32:52.000+05:30",
          "updated_at": "2024-07-22T12:32:52.000+05:30",
          "created_by_user": "system",
          "assigned_user": {
            "id": 1100,
            "name": "satishcreative"
          }
        },
        {
          "id": 489,
          "title": "Project Integration",
          "parent": "CampaignTask",
          "subject": "Project Integration",
          "task_type": "Project Integration",
          "description": null,
          "status": "TODO",
          "assigned_user_id": null,
          "created_by": 0,
          "campaign_id": 85,
          "created_at": "2024-07-22T12:32:52.000+05:30",
          "updated_at": "2024-07-22T12:32:52.000+05:30",
          "created_by_user": "system",
          "assigned_user": {}
        },
        {
          "id": 490,
          "title": "Webhook Integration",
          "parent": "CampaignTask",
          "subject": "Webhook Integration",
          "task_type": "Webhook Integration",
          "description": null,
          "status": "TODO",
          "assigned_user_id": null,
          "created_by": 0,
          "campaign_id": 85,
          "created_at": "2024-07-22T12:32:52.000+05:30",
          "updated_at": "2024-07-22T12:32:52.000+05:30",
          "created_by_user": "system",
          "assigned_user": {}
        },
        {
          "id": 491,
          "title": "Marketing",
          "parent": "CampaignTask",
          "subject": "Marketing",
          "task_type": "Marketing",
          "description": null,
          "status": "TODO",
          "assigned_user_id": null,
          "created_by": 0,
          "campaign_id": 85,
          "created_at": "2024-07-22T12:32:52.000+05:30",
          "updated_at": "2024-07-22T12:32:52.000+05:30",
          "created_by_user": "system",
          "assigned_user": {}
        },
        {
          "id": 492,
          "title": "Pre Sales Pitch",
          "parent": "CampaignTask",
          "subject": "Pre Sales Pitch",
          "task_type": "Pre Sales Pitch",
          "description": null,
          "status": "TODO",
          "assigned_user_id": null,
          "created_by": 0,
          "campaign_id": 85,
          "created_at": "2024-07-22T12:32:52.000+05:30",
          "updated_at": "2024-07-22T12:32:52.000+05:30",
          "created_by_user": "system",
          "assigned_user": {}
        },
        {
          "id": 486,
          "title": "Finance Approval",
          "parent": "CampaignTask",
          "subject": "Finance Approval",
          "task_type": "Finance Approval",
          "description": null,
          "status": "TODO",
          "assigned_user_id": 1099,
          "created_by": 0,
          "campaign_id": 85,
          "created_at": "2024-07-22T12:32:51.000+05:30",
          "updated_at": "2024-07-22T12:32:51.000+05:30",
          "created_by_user": "system",
          "assigned_user": {
            "id": 1099,
            "name": "satishFinance"
          }
        },
        {
          "id": 487,
          "title": "Budget Allocation",
          "parent": "CampaignTask",
          "subject": "Budget Allocation",
          "task_type": "Budget Allocation",
          "description": null,
          "status": "TODO",
          "assigned_user_id": 1099,
          "created_by": 0,
          "campaign_id": 85,
          "created_at": "2024-07-22T12:32:51.000+05:30",
          "updated_at": "2024-07-22T12:32:51.000+05:30",
          "created_by_user": "system",
          "assigned_user": {
            "id": 1099,
            "name": "satishFinance"
          }
        }
      ]
    },

    {
      "id": 2,
      "title": "CreativeJob",
      "child": [
        {
          "id": 14,
          "title": "Official",
          "parent": "CreativeJob",
          "job_type": "Official",
          "job_category": "Content",
          "platform": "Meta",
          "campaign_type": "P Max",
          "creative_type": "Static creative without text",
          "creative_size": [],
          "assets_count": null,
          "creative_description": "ewerfdwer",
          "priority": "Medium",
          "landing_page_link": "ewrrewrew",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "erwrew",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T12:31:47.000+05:30",
          "updated_at": "2024-07-24T12:31:47.000+05:30",
          "open_file_link": [],
          "asset": null,
          "open_files": null,
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 15,
          "title": "Official",
          "parent": "CreativeJob",
          "job_type": "Official",
          "job_category": "Content",
          "platform": "undefined",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            "1200-628,970-90"
          ],
          "assets_count": null,
          "creative_description": "sdfdsfdsf",
          "priority": "Medium",
          "landing_page_link": "dsfdsffds",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "sdfsdf",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T12:44:35.000+05:30",
          "updated_at": "2024-07-24T12:44:35.000+05:30",
          "open_file_link": [
            ""
          ],
          "asset": null,
          "open_files": null,
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 16,
          "title": "Official",
          "parent": "CreativeJob",
          "job_type": "Official",
          "job_category": "Content",
          "platform": "Linkedin",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            "1200-1200"
          ],
          "assets_count": null,
          "creative_description": "ewerwwe",
          "priority": "Medium",
          "landing_page_link": "wererw",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "werewr",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T13:33:10.000+05:30",
          "updated_at": "2024-07-24T13:33:10.000+05:30",
          "open_file_link": [
            ""
          ],
          "asset": null,
          "open_files": [
            {
              "id": 24149,
              "name": "Group (5).png",
              "content_type": "image/png",
              "byte_size": 1502,
              "created_at": "2024-07-24T13:33:10.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/rxB5RvDDBn3i6vUcf1cbynVh"
            },
            {
              "id": 24150,
              "name": "Group (6).png",
              "content_type": "image/png",
              "byte_size": 1936,
              "created_at": "2024-07-24T13:33:10.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/yE6TYfGYF86ksc5kpLsqg8Xf"
            }
          ],
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 17,
          "title": "Internal",
          "parent": "CreativeJob",
          "job_type": "Internal",
          "job_category": "Content",
          "platform": "Meta",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            "1080-1920"
          ],
          "assets_count": null,
          "creative_description": "erwerrew",
          "priority": "Medium",
          "landing_page_link": "wererw",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "ewrerw",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T13:36:57.000+05:30",
          "updated_at": "2024-07-24T13:36:57.000+05:30",
          "open_file_link": [],
          "asset": null,
          "open_files": null,
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 18,
          "title": "Internal",
          "parent": "CreativeJob",
          "job_type": "Internal",
          "job_category": "Content",
          "platform": "Meta",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            "1080-1920"
          ],
          "assets_count": null,
          "creative_description": "erwerrew",
          "priority": "Medium",
          "landing_page_link": "wererw",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "ewrerw",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T13:37:35.000+05:30",
          "updated_at": "2024-07-24T13:37:35.000+05:30",
          "open_file_link": [],
          "asset": null,
          "open_files": [
            {
              "id": 24151,
              "name": "Group (6).png",
              "content_type": "image/png",
              "byte_size": 1936,
              "created_at": "2024-07-24T13:37:35.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/ig3SzdybBRbcEQwE16uiZHQp"
            },
            {
              "id": 24152,
              "name": "Group (5).png",
              "content_type": "image/png",
              "byte_size": 1502,
              "created_at": "2024-07-24T13:37:35.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/evgDA1vvbeJTtB5Q9FnuoaU5"
            }
          ],
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 19,
          "title": "Internal",
          "parent": "CreativeJob",
          "job_type": "Internal",
          "job_category": "Content",
          "platform": "Meta",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            "1080-1920"
          ],
          "assets_count": null,
          "creative_description": "erwerrew",
          "priority": "Medium",
          "landing_page_link": "wererw",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "ewrerw",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T13:38:07.000+05:30",
          "updated_at": "2024-07-24T13:38:07.000+05:30",
          "open_file_link": [],
          "asset": null,
          "open_files": [
            {
              "id": 24153,
              "name": "Group (6).png",
              "content_type": "image/png",
              "byte_size": 1936,
              "created_at": "2024-07-24T13:38:07.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/2SjcfTTWaAmXGkrt7LsEC5Fv"
            },
            {
              "id": 24154,
              "name": "Group (5).png",
              "content_type": "image/png",
              "byte_size": 1502,
              "created_at": "2024-07-24T13:38:07.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/wAPeaz4GPw1rbj9BqQbscJCP"
            }
          ],
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 20,
          "title": "Official",
          "parent": "CreativeJob",
          "job_type": "Official",
          "job_category": "Content",
          "platform": "Meta",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            ""
          ],
          "assets_count": null,
          "creative_description": "",
          "priority": "Low",
          "landing_page_link": "",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "rerew",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T13:41:00.000+05:30",
          "updated_at": "2024-07-24T13:41:00.000+05:30",
          "open_file_link": [
            ""
          ],
          "asset": null,
          "open_files": null,
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 21,
          "title": "Official",
          "parent": "CreativeJob",
          "job_type": "Official",
          "job_category": "Content",
          "platform": "Meta",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            ""
          ],
          "assets_count": null,
          "creative_description": "",
          "priority": "Low",
          "landing_page_link": "",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "rerew",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T13:41:19.000+05:30",
          "updated_at": "2024-07-24T13:41:19.000+05:30",
          "open_file_link": [
            ""
          ],
          "asset": null,
          "open_files": null,
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 22,
          "title": "Official",
          "parent": "CreativeJob",
          "job_type": "Official",
          "job_category": "Content",
          "platform": "Meta",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            "1080-1080,820-360,800-800,1080-1920"
          ],
          "assets_count": null,
          "creative_description": "dsffsdfsd",
          "priority": "Medium",
          "landing_page_link": "sdfsfdfsd",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "sdffsd",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T14:30:05.000+05:30",
          "updated_at": "2024-07-24T14:30:05.000+05:30",
          "open_file_link": [
            "fdsfsfds32,dfd32432,fdfds67"
          ],
          "asset": null,
          "open_files": [
            {
              "id": 24156,
              "name": "Group (6).png",
              "content_type": "image/png",
              "byte_size": 1936,
              "created_at": "2024-07-24T14:30:05.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/UJ7yhhe9ihFc2yPLJh2MCkZC"
            },
            {
              "id": 24157,
              "name": "Group (5).png",
              "content_type": "image/png",
              "byte_size": 1502,
              "created_at": "2024-07-24T14:30:05.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/aHrCjpRpgwLwTUqNHenGQ8sV"
            }
          ],
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 23,
          "title": "Internal",
          "parent": "CreativeJob",
          "job_type": "Internal",
          "job_category": "Content",
          "platform": "Google",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            "1200-628,970-90"
          ],
          "assets_count": null,
          "creative_description": "sfddfsfsdd",
          "priority": "High",
          "landing_page_link": "sdfdfsfdsfsddfs",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "sdfsdffsd",
          "assigned_to_id": null,
          "created_by_id": 1,
          "campaign_id": 85,
          "created_at": "2024-07-24T17:20:20.000+05:30",
          "updated_at": "2024-07-24T17:20:20.000+05:30",
          "open_file_link": [
            "sdffsdfsdfds,sdfdsfsdfsdfsfd,dsffd"
          ],
          "asset": null,
          "open_files": [
            {
              "id": 24158,
              "name": "Group (6).png",
              "content_type": "image/png",
              "byte_size": 1936,
              "created_at": "2024-07-24T17:20:20.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/AC4nvnWPcyxYVCXpYURPZziR"
            },
            {
              "id": 24159,
              "name": "Group (5).png",
              "content_type": "image/png",
              "byte_size": 1502,
              "created_at": "2024-07-24T17:20:20.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/CEo2iPckjJjCkZBd7cfUSQvf"
            }
          ],
          "created_by": {
            "id": 1,
            "name": "Vishal sharma"
          },
          "assigned_user": {}
        },
        {
          "id": 24,
          "title": "Internal",
          "parent": "CreativeJob",
          "job_type": "Internal",
          "job_category": "Creative",
          "platform": "Meta",
          "campaign_type": null,
          "creative_type": null,
          "creative_size": [
            "1080-1080,1080-1920"
          ],
          "assets_count": null,
          "creative_description": "https://staging-leadmanager.automateleads.ai/page/campaign-details/85",
          "priority": "High",
          "landing_page_link": "https://staging-leadmanager.automateleads.ai/page/campaign-details/85",
          "keyword_for_ad_copies": null,
          "status": null,
          "completed_at": null,
          "creative_name": "Test 1",
          "assigned_to_id": null,
          "created_by_id": 1021,
          "campaign_id": 85,
          "created_at": "2024-07-25T11:23:34.000+05:30",
          "updated_at": "2024-07-25T11:23:34.000+05:30",
          "open_file_link": [
            "https://staging-leadmanager.automateleads.ai/page/campaign-details/85"
          ],
          "asset": null,
          "open_files": [
            {
              "id": 24160,
              "name": "Lion.jpg",
              "content_type": "image/jpeg",
              "byte_size": 15317,
              "created_at": "2024-07-25T11:23:34.000+05:30",
              "link": "https://persquarefeet-lms.s3.us-east-2.amazonaws.com/S7sr9jgjDeyVm57qqqNRjDKL"
            }
          ],
          "created_by": {
            "id": 1021,
            "name": "Vendor Admin"
          },
          "assigned_user": {}
        }
      ]
    },

    {
      "id": 3,
      "title": "pre_sales_job",
      "child": []
    },

    {
      "id": 4,
      "title": "escalations",
      "child": []
    },

  ]

  constructor(
    private _serverService: ServerService,
    private dialog: MatDialog,
    private _clipBoardService: ClipBoardService,
    private _activatedRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    // console.log(data)
    // debugger;
    
    this.allCommentTypeData = data;
    // console.log(this.allCommentTypeData)
    if(this.viewMediaDetailRequest){
      this.allCommentTypeData = this.viewMediaDetailRequest
      this.tableRowData = this.allCommentTypeData
    }
    this.allCommentTypeData.commentType == 'viewmediaplanrequest'
 
    this._activatedRoute.params.subscribe((params: any) => {
      this.campaignId = params.id
      //console.log(params)
    })
   

    // console.log(data)

    this.tableRowData = data
    // console.log(this.tableRowData)

  }

  ngOnInit() {

    this.quillConfig = {
      //toolbar: '.toolbar',
      toolbar: {
        container: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ 'header': 1 }, { 'header': 2 }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'script': 'sub' }, { 'script': 'super' }],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          //[{ 'direction': 'rtl' }],                         // text direction
          [{ 'size': ['small', false, 'large', 'huge'] }],
          //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //[{ 'color': [] }, { 'background': [] }],
          [{ 'font': [] }],
          [{ 'align': [] }],
          ['clean'],
          ['link'],
          //['link', 'image', 'video']
        ],

      },

      imageResize: {
        modules: ['Resize', 'DisplaySize', 'Toolbar']
      },


      mention: {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ["@", "#"],
        source: (searchTerm, renderList, mentionChar) => {

          let values;

          if (mentionChar === "@") {
            //values = this.atValues;
            values = this.salePersonList;
          } else {
            //values = this.hashValues;
          }

          if (searchTerm.length === 0) {
            renderList(values, searchTerm);
          } else {
            const matches = [];
            for (var i = 0; i < values.length; i++)
              if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase()))
                matches.push(values[i]);
            renderList(matches, searchTerm);
          }
        },
      },

      "emoji-toolbar": true,
      "emoji-textarea": false,
      "emoji-shortname": true,

      keyboard: {
        bindings: {
          shiftEnter: {
            key: 13,
            shiftKey: true,
            handler: (range, context) => {
              // Handle shift+enter
              //console.log("shift+enter")
            }
          },
          enter: {
            key: 13,
            handler: (range, context) => {
              //console.log("enter");
              return true;
            }
          }
        }
      }
    }

    if ((this.htmlText != null && this.htmlText != '') && (this.selectedCommentCategory != null && this.selectedCommentCategory != '')) {
      this.btnStatus = true
    } else {
      this.btnStatus = false
    }

    //console.log(this.data.commentType)
    if (this.data.commentType == 'ascalation') {
      this.getComment('Escalation', this.data.id)
      this.selectedCommentCategory = { id: this.data.id, title: 'Escalation', titleView: 'Escalation', parent: 'Escalation' };
      this.selectedCommentViewCategory = { id: this.data.id, title: 'Escalation', titleView: 'Escalation', parent: 'Escalation' }
    } else if (this.data.commentType == 'creative') {
      this.getComment('CreativeJob', this.data.id)
      this.selectedCommentCategory = { id: this.data.id, title: 'CreativeJob', titleView: 'Creative Job', parent: 'CreativeJob' };
      this.selectedCommentViewCategory = { id: this.data.id, title: 'CreativeJob', titleView: 'Creative Job', parent: 'CreativeJob' }
    } else if (this.data.commentType == 'presales') {
      this.getComment('PreSalesJob', this.data.id)
      this.selectedCommentCategory = { id: this.data.id, title: 'PreSalesJob', titleView: 'PreSales Job', parent: 'PreSalesJob' };
      this.selectedCommentViewCategory = { id: this.data.id, title: 'PreSalesJob', titleView: 'PreSales Job', parent: 'PreSalesJob' }
    } else if (this.data.commentType == 'marketingJob') {
      this.getComment('MarketingJob', this.data.id)
      this.selectedCommentCategory = { id: this.data.id, title: 'MarketingJob', titleView: 'Marketing Job', parent: 'MarketingJob' };
      this.selectedCommentViewCategory = { id: this.data.id, title: 'MarketingJob', titleView: 'Marketing Job', parent: 'MarketingJob' }
    } 

    else if(this.data.commentType=='commentmaster'){
      // console.log(this.data)
      this.allCommentTypeData = this.data
      this.getComment(this.data.lm_object_type, this.data.lm_object_id)
      this.selectedCommentCategory = { id: this.data.lm_object_id, title: this.data.lm_object_type, titleView: this.data.lm_object_type, parent: this.data.lm_object_type };
      this.selectedCommentViewCategory = { id: this.data.lm_object_id, title: this.data.lm_object_type, titleView: this.data.lm_object_type, parent: this.data.lm_object_type }
    }
    else if (this.data.commentType == 'mediaPlanRequest') {
      // this.getComment('mediaPlanRequest', this.data.id)
    
      this.getMediaPlanRequestComment(this.data.id)
      this.selectedCommentCategory = { id: this.data.id, title: 'mediaPlanRequest', titleView: 'mediaPlanRequest', parent: 'mediaPlanRequest' };
      this.selectedCommentViewCategory = { id: this.data.id, title: 'mediaPlanRequest', titleView: 'mediaPlanRequest', parent: 'mediaPlanRequest' }
    } 
    else if(this.viewMediaDetailRequest){
      if(this.viewMediaDetailRequest.commentType == 'mediaPlanRequest'){
      //  this.viewMediaDetailRequest.commentType == 'mediaPlanRequest'
      this.allCommentTypeData = this.viewMediaDetailRequest
      this.allCommentTypeData.commentType = 'viewmediaplanrequest'
      this.data = this.viewMediaDetailRequest
       this.getMediaPlanRequestComment(this.viewMediaDetailRequest.id)
       this.selectedCommentCategory = { id: this.viewMediaDetailRequest.id, title: 'mediaPlanRequest', titleView: 'mediaPlanRequest', parent: 'mediaPlanRequest' };
       this.selectedCommentViewCategory = { id: this.viewMediaDetailRequest.id, title: 'mediaPlanRequest', titleView: 'mediaPlanRequest', parent: 'mediaPlanRequest' }
      }
      }
    else {
      this.getComment(this.moduleType, this.campaignId)
      this.selectedCommentViewCategory = { id: this.campaignId, title: 'Campaign', titleView: 'Campaign', parent: 'Campaign' }
    }

    this.convertBase64ToBlob("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASPSURBVHgB7ZpfTFtVHMe/t73tLR2l/2mhtIy/k4wBY1SBZdBtQOZgD5MZXdREXeYjezDxzaAxmfHBRHlxiS8kEpPFqNuDqNFNwChbJg433Jjd6Dqg/P9TVgKl/zz3kJQ1awfO6i7b/TbN/XPO+Z3zye/Pub0po8k/4EAYDmxmSdDFUggGrdjMCvMsj4lEEKFJBBGaRBChSQQRmkQQoUkEEZpEEKHpyQJJkYcf2F6Yb4uem406KDgu5pphGFRWbEdtdRn95tgyou0WszHGVqbJED3PtppX7edasZ7WBTGoAmAliUE4ToaWY83Qa9PodV6uBZbMtcXsr9mFFE6O8pJCDDrdcA6NIJ3A1dVW0PamhqoYew377PSo16vRcvwIdBoVWt54Pmr/oUE0ygDkbATVBd647TWVpXj/4w449pQnmIFBKBLB/LwPE1Nz8IxP42Lfn5DLZLQ5En8USopycar9LFrfeh0ftHVgbyL7GwHJ0vkx7uVQZvNhOSCN28eUrsPo+BS2KBRx2xny4RWOrHm1tDgfEQLHhxx/jKdteTbivWFIJBIMeyahTGB/QyCpXAhbDcvwLknhnuGQY1y6b7KBQRc97/1tgIRRBfj1Mvf0YaUShEJhWC0m1FSVwrF7JxrrqnD1+hBtvxeDB+Nv7NuzC9+eu0DD8RqxX1SYjd5Lq/b/MUh59l2shBjML7KY9cnpBFbioUytP9rnYH0l+q866Tkf+zk2M/WOJSM92kdGQigYDGLUM4We3j/Q9ctlnPzoM1TZt1NvhENrniog+XXdeQdZGUa4RyZQUfoUPmk/Q/LJDqdrBFttpkTLBRvvppJ4QqUMIhhmICc54ppOoTninlZgR5YPnjkOBr0Gl/pvxIwbuu2B3x+AXpeG144ehH8lgMGbbtq2uLQc09fr9dFj35UbtO+Sf4WED0c8cRHKFI7YUBOo1bHDo5NQqZTE/hjM6XqMT87ct2ZGk3vgnU3/XiuCd//3DZHmwX+gpIFISJn9/FTrAxe6jWycx18+FHOPzwuTTo6GJhmkGg4PK6lCm8+/MnXgX6qxvhoBktRq1RaS3CEcbqyhmyFfBF44vB/2siJ47/oIjBUpJBdc7jE65thLTZAyQQxZWaTJ9HilYS/MZHfnbTU31sJo0ODW7dH1pu9Omkeq7MU4ffYnNDiehjXLhLkFH87/3IcjhxyYmJyFQiGnpZffNngAC6lMmWY9XHfG8F3PNdRF7DjxbCPaPv2S9J+BQaum+8fR5voNzZ8UEL7aZJj0qCMekLIS+lgRIBXLu7CInTsKaVn+/cpqheMjr/OHXrSdPIHOHy9EbajVqVghY2hJDkfwXFMtGfMXZucWNrSGpIRWQZ4VXb/243xPH266RmnpHHJ7MEdK7IJvEUa9FqpUJS6ThWkJ5FffdGP3MyU4feYc2SwjsGamY2pmHl939uBFEoZSVopbZN8oJo8pM7Ne9A8411tC9yMpv2+/+So6vviehlVSRMovi0eg9z5sR7Il/kIUmkQQoUkEEZpEEKFJBBGaRBChSQQRmh4bEJb/0xbC2NwiDH8DVkt6TIG7968AAAAASUVORK5CYII=")

    //console.log(this.commentData)
    // console.log(this.selectedCommentViewCategory)

    this.selectedCommentViewCategory = { "id": "117", "title": "Campaign", "parent": "Campaign", "parentview": "Campaign" };
    this.getSP()
  }

  ngOnChanges() {
    //debugger

    if (this.taskData != null && this.taskData != undefined) {
      this.selectedCommentCategory = this.taskData;
      //this.selectedCommentViewCategory = this.taskData;
    } else {
      this.selectedCommentCategory = { id: this.campaignId, title: 'Campaign', parent: 'Campaign', parentview: 'Campaign' };
      //this.selectedCommentViewCategory = { id: this.campaignId, title: 'Campaign', parent: 'Campaign', parentview: 'Campaign' };
    }

  
    // console.log(this.selectedCommentViewCategory)

    //this.selectedCommentViewCategory={ "id": "117", "title": "Campaign", "parent": "Campaign", "parentview": "Campaign" };
  }


  // getUserFun(item){

  //     let index = this.userList.findIndex(user => user.id == item.id);

  //     if (index != -1) {
  //       this.userList.splice(index, 1);
  //     } else {
  //       this.userList.push(item)
  //     }

  //     console.log(this.userList)

  // }

  convertBase64ToBlob(base64Image: any) {
    // Split into two parts
    const parts = base64Image.split(';base64,');

    // Hold the content type
    const imageType = parts[0].split(':')[1];

    // Decode Base64 string
    const decodedData = window.atob(parts[1]);

    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);

    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }

    // Return BLOB image after conversion
    //return new Blob([uInt8Array], { type: imageType });
    // console.log(new Blob([uInt8Array], { type: imageType }))
  }
  getMediaPlanRequestComment(data:any){
    this.showComponentLoader = true
// console.log(data)
    // let body = {
    //   "module_type": module_type,
    //   "module_id": module_id
    // }

    let url = "/media_plan_request/"+data;
    this._serverService.getCommentMediaPlanRequest(url, this.authToken).subscribe(data => {
      //console.log(data);
      //this.allComment=data
      //this.htmlText=data.description

      data.comments.forEach((item, i) => {

        if (item.description && item.description.includes('<img')) {

          var imgRegex = /<img[^>]+>/g;

          var imgTags = item.description.match(imgRegex);
          //console.log(imgTags)

          var srcAttr;
          if (imgTags != null) {
            imgTags.forEach((imgTag, j) => {

              var srcRegex = /src="([^"]+)"/g;
              var srcAttributes = [];
              var match;

              while ((match = srcRegex.exec(item.description)) !== null) {
                srcAttributes.push(match[1]);
                item['imgSrc'] = srcAttributes
                //console.log(srcAttributes[j])
              }

              //item.description = item.description.replace(imgTag, "<a (click)='downloadCommentPic()' href=" + srcAttributes[j] + " class='download-pic'><span class='material-icons'>download</span></a>" + imgTag);
              item.description = item.description.replace(imgTag, "<a onclick='downloadCommentPic()' class='download-pic'><span class='material-icons'>download</span></a>" + imgTag);
            });
          }
        }
      });

      this.allComment = data.comments

      //console.log(this.allComment)

      this.showComponentLoader = false
    }, err => {
      this.showComponentLoader = false
      this._clipBoardService.checkServerError(err, this.authToken)
    }
    )

  }
  getComment(module_type?: any, module_id?: any) {

    //debugger

    this.showComponentLoader = true

    let body = {
      "module_type": module_type,
      "module_id": module_id
    }

    let url = "/campaign_module/index_with_filters";
    this._serverService.getComment(url, body, this.authToken).subscribe(data => {
      //console.log(data);
      //this.allComment=data
      //this.htmlText=data.description

      data.forEach((item, i) => {

        if (item.description && item.description.includes('<img')) {

          var imgRegex = /<img[^>]+>/g;

          var imgTags = item.description.match(imgRegex);
          //console.log(imgTags)

          var srcAttr;
          if (imgTags != null) {
            imgTags.forEach((imgTag, j) => {

              var srcRegex = /src="([^"]+)"/g;
              var srcAttributes = [];
              var match;

              while ((match = srcRegex.exec(item.description)) !== null) {
                srcAttributes.push(match[1]);
                item['imgSrc'] = srcAttributes
                //console.log(srcAttributes[j])
              }

              //item.description = item.description.replace(imgTag, "<a (click)='downloadCommentPic()' href=" + srcAttributes[j] + " class='download-pic'><span class='material-icons'>download</span></a>" + imgTag);
              item.description = item.description.replace(imgTag, "<a onclick='downloadCommentPic()' class='download-pic'><span class='material-icons'>download</span></a>" + imgTag);
            });
          }
        }
      });

      this.allComment = data

      //console.log(this.allComment)

      this.showComponentLoader = false
    }, err => {
      this.showComponentLoader = false
      this._clipBoardService.checkServerError(err, this.authToken)
    }
    )

  }
  getMediaCommentMaster(data:any){
    this.showComponentLoader = true
// console.log(data)
    // let body = {
    //   "module_type": module_type,
    //   "module_id": module_id
    // }

    let url = "/media_plan_request/"+data;
    this._serverService.getCommentMediaPlanRequest(url, this.authToken).subscribe(data => {
      //console.log(data);
      //this.allComment=data
      //this.htmlText=data.description

      data.comments.forEach((item, i) => {

        if (item.description && item.description.includes('<img')) {

          var imgRegex = /<img[^>]+>/g;

          var imgTags = item.description.match(imgRegex);
          //console.log(imgTags)

          var srcAttr;
          if (imgTags != null) {
            imgTags.forEach((imgTag, j) => {

              var srcRegex = /src="([^"]+)"/g;
              var srcAttributes = [];
              var match;

              while ((match = srcRegex.exec(item.description)) !== null) {
                srcAttributes.push(match[1]);
                item['imgSrc'] = srcAttributes
                //console.log(srcAttributes[j])
              }

              //item.description = item.description.replace(imgTag, "<a (click)='downloadCommentPic()' href=" + srcAttributes[j] + " class='download-pic'><span class='material-icons'>download</span></a>" + imgTag);
              item.description = item.description.replace(imgTag, "<a onclick='downloadCommentPic()' class='download-pic'><span class='material-icons'>download</span></a>" + imgTag);
            });
          }
        }
      });

      this.allComment = data.comments

      //console.log(this.allComment)

      this.showComponentLoader = false
    }, err => {
      this.showComponentLoader = false
      this._clipBoardService.checkServerError(err, this.authToken)
    }
    )

  }
  downloadCommentPic(base64Data) {

    var filename = 'image.png';

    base64Data.forEach((item) => {

      // Create a link element
      var link = document.createElement('a');

      // Set href attribute to base64 data URI
      link.href = item;

      // Set download attribute to specify filename
      link.download = filename;

      // Append the link to the document body
      document.body.appendChild(link);

      // Trigger a click event on the link to initiate download
      link.click();

      // Remove the link from the document body
      document.body.removeChild(link);

    })


  }

  getSP() {

    this.showComponentLoader = true

    let url;
   
    if(this.allCommentTypeData.commentType){
    if(this.allCommentTypeData.commentType.toLowerCase() == 'mediaplanrequest'  ||
     this.allCommentTypeData.commentType.toLowerCase() == 'viewmediaplanrequest')
     {
      url = "/campaign_module/user_list?user_type=OrgAdminSalesAdmin";
     }
     else{
      
      url = "/campaign_module/user_list";
     
  }
    }
    else{
      
        url = "/campaign_module/user_list";
       
    }
    this._serverService.getSalePerson(url, this.authToken).subscribe(data => {
      //this.salePersonList = data.data
      data.data = data.data.map(function (obj) {
        obj['value'] = obj['name'];
        delete obj['name'];
        return obj;
      });
      //console.log(data.data);

      this.salePersonList = data.data
      this.commentSalePersonList = data.data
      //console.log(this.salePersonList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this._clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  onSelectionChanged = (event) => {
    // console.log('onSelectionChanged-oldRange ', event.oldRange)
    // console.log('onSelectionChanged-range ', event.range)
  }

  onContentChanged = (event) => {
    //console.log('onContentChanged ', event.html);

    this.salePersonList = this.commentSalePersonList

    //var myString = '<p><span class="mention" data-index="0" data-denotation-char="@" data-id="1099" data-value="testSatol"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span>testSatol</span></span> <span class="mention" data-index="1" data-denotation-char="@" data-id="1087" data-value="inaam user12"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span>inaam user12</span></span> </p>';

    if (this.htmlText != null && this.htmlText != '') {
      var regex = /data-id="([^"]+)"/g;
      var matches = event.html.match(regex);
      var dataIds = []

      if (matches) {
        matches.map(function (match) {
          //return match.match(/data-id="([^"]+)"/)[1];        
          dataIds.push(Number(match.match(/data-id="([^"]+)"/)[1]));
        });

        this.dataIdsArr = dataIds

        var arr2Ids: any = new Set(dataIds.map(item => item));
        //console.log(arr2Ids)

        var result = this.salePersonList.filter(item => !arr2Ids.has(item.id));
        //console.log(result)

        this.salePersonList = result
        //console.log(this.salePersonList)
        //console.log('data-ids:', dataIds);
      } else {
        //console.log('No data-id attributes found');
      }
    }


    this.htmlText = event.html
    if ((this.htmlText != null && this.htmlText != '') && (this.selectedCommentCategory != null && this.selectedCommentCategory != '')) {
      this.btnStatus = true
    } else {
      this.btnStatus = false
    }

    // let index = this.salePersonList.findIndex(user => user.id == event.html.id);

    // if (index != -1) {
    //   this.salePersonList.splice(index, 1);
    // } else {
    //   this.salePersonList.push(event.html)
    // }

    // console.log(this.salePersonList)

  }

  commentCategoryChange($event) {
    if ((this.htmlText != null && this.htmlText != '') && (this.selectedCommentCategory != null && this.selectedCommentCategory != '')) {
      this.btnStatus = true
    } else {
      this.btnStatus = false
    }
  }

  getCategoryWiseComment(event: any) {
    //console.log(event)
    if (event == undefined) {
      this.getComment('Campaign', this.campaignId)
    } else {
      this.getComment(event.parent, event.id)
    }

  }

  submit() {

    // console.log(this.htmlText)
    // return false
    // debugger;
    this.btnStatus = false

    let body;

    if (this.tableRowData == undefined || this.tableRowData.commentType != 'ascalation') {
      body = {
        //"subject": "Campaign",
        "subject": this.selectedCommentCategory.parentview,
        "description": this.htmlText,
        // "module_type": "Campaign",
        // "module_id": Number(this.campaignId)
        "module_type": this.selectedCommentCategory.parent,
        "module_id": Number(this.selectedCommentCategory.id)
      }

      var doc:any = new DOMParser().parseFromString(this.htmlText, "text/xml");
     
    }

    if (this.tableRowData.commentType == 'ascalation' && this.tableRowData != undefined) {
     
      this.selectedCommentCategory.parentview  = "Escalation Job #" +this.data.id + " | " + this.data.escalation_category;
      body = {
        //"subject": "Campaign",
        "subject": this.selectedCommentCategory.parentview,
        "description": this.htmlText,
        "module_type": 'Escalation',
        "module_id": Number(this.data.id)
      }
    }

    if (this.tableRowData.commentType == 'creative' && this.tableRowData != undefined) {
      this.selectedCommentCategory.parentview  = "Creative Job #" +this.data.id + " | " + this.data.job_type;
      body = {
        //"subject": "Campaign",
        "subject": this.selectedCommentCategory.parentview,
        "description": this.htmlText,
        "module_type": 'CreativeJob',
        "module_id": Number(this.data.id)
      }
    }

    if (this.tableRowData.commentType == 'presales' && this.tableRowData != undefined) {
      
      this.selectedCommentCategory.parentview  = "Presales Job #" +this.data.id + " | " + this.data.calling_type;
      body = {
        //"subject": "Campaign",
        "subject": this.selectedCommentCategory.parentview,
        "description": this.htmlText,
        "module_type": 'PreSalesJob',
        "module_id": Number(this.data.id)
      }
    }

    if (this.tableRowData.commentType == 'marketingJob' && this.tableRowData != undefined) {
      
      this.selectedCommentCategory.parentview  = "Marketing Job #" +this.data.id + " | " + this.data.job_type;
      body = {
        //"subject": "Campaign",
        "subject": this.selectedCommentCategory.parentview,
        "description": this.htmlText,
        "module_type": 'MarketingJob',
        "module_id": Number(this.data.id)
      }
    }
    if (this.tableRowData.commentType == 'commentmaster' && this.tableRowData != undefined) {
     
      this.selectedCommentCategory.parentview  = this.data.lm_object_type + "#" +this.data.lm_object_id 
      body = {
        //"subject": "Campaign",
        "subject": this.data.subject,
        "description": this.htmlText,
        "module_type": this.data.lm_object_type,
        "module_id": Number(this.data.lm_object_id)
      }
      
    }
    // this.data.lm_object_type, this.data.lm_object_id)
    this._serverService.addCampaignComment(body,
      this.authToken).subscribe(data => {
        // console.log(data);
        localStorage.setItem('masterComment',"true")
        this.htmlText = '';
        //this.selectedCommentCategory = null;
        this.btnStatus = true

        if (this.dataIdsArr != undefined) {

          let innerBody = {
            "comment_id": data.id,
            "notify_user_id": this.dataIdsArr
          }

          let url = "/campaign_module/comment/add_notify_user";
          this._serverService.commentNotifyUser(url, innerBody, this.authToken).subscribe(innerData => {
            // console.log(innerData);  

            // if (this.data.commentType == 'ascalation') {
            //   this.getComment('Escalation', this.data.id)
            //   return false
            // } else if (this.data.commentType == 'creative') {
            //   this.getComment('CreativeJob', this.data.id)
            //   return false
            // } else if (this.data.commentType == 'presales') {
            //   this.getComment('PreSalesJob', this.data.id)
            //   return false
            // } if (this.data.commentType == 'marketingJob') {
            //   this.getComment('MarketingJob', this.data.id)
            //   return false
            // } else {
            //   this.getComment(this.moduleType, this.campaignId)
            //   return false
            // }

            //this._clipBoardService.showMessgeInText('Comment Save  Successfully', 'success-snackbar')
          }, err => {
            //this.btnStatus = true
            this._clipBoardService.checkServerError(err, this.authToken)
          })
        }

        this._clipBoardService.showMessgeInText('Comment Save Successfully', 'success-snackbar')

        if (this.data.commentType == 'ascalation') {
          this.getComment('Escalation', this.data.id)
          return false
        } else if (this.data.commentType == 'creative') {
          this.getComment('CreativeJob', this.data.id)
          return false
        } else if (this.data.commentType == 'presales') {
          this.getComment('PreSalesJob', this.data.id)
          return false
        } 
        else if(this.data.commentType == 'commentmaster'){
          this.getComment(this.data.lm_object_type, this.data.lm_object_id)
          return false
        }
        if (this.data.commentType == 'marketingJob') {
          this.getComment('MarketingJob', this.data.id)
          return false
        } else {
          this.getComment(this.moduleType, this.campaignId)
          return false
        }

      }, err => {
        this.btnStatus = true
        this._clipBoardService.checkServerError(err, this.authToken)
      }
      )
  }
submitMediaRequestComment(){
  this.btnStatus = false
  let body = {
  "subject": this.selectedCommentCategory.parentview,
  "description": this.htmlText,
  "notify_user_id": this.dataIdsArr,
  "media_plan_request_id":this.data.id

  }
  let url = "media_plan_request/comment";
  this._serverService.addCommentMediaRequest(url, body, this.authToken).subscribe(innerData => {
    this._clipBoardService.showMessgeInText('Comment Save Successfully', 'success-snackbar')
    this.getMediaPlanRequestComment(this.data.id);
    this.htmlText = '';
    return false;
  },
  err => {
    this.btnStatus = true
    this._clipBoardService.checkServerError(err, this.authToken)
  })

}
  clear() {
    this.htmlText = '';
    //this.selectedCommentCategory = null
  }

  // getCommentCategory(event){

  // }

  getBgColor(item:any){
    // debugger;
  //  item = item.commentable.module_name;
    item = item.toLowerCase()
    switch(item){
      case 'escalation':return {'background-color':'#FCD2CD','border': '0.5px solid rgba(220, 185, 181, 1)'};
    
      case 'marketingjob':return {'background-color':'#FDE2C9','border': '0.5px solid rgba(228, 203, 182, 1)'}
    
      case 'presalesjob':return {'background-color':'rgba(217, 255, 233, 0.7)','border':'0.5px solid rgba(206, 238, 220, 1)'}
    
      case 'creativejob':return {'background-color':'#F8E6FF','border': '0.5px solid rgba(233, 216, 240, 1)'}
    
      case 'campaigntask':return {'background-color':'#FFF9E0','border': '0.5px solid #F0E9CF'}
    
      case 'campaign':return {'background-color':'#EAF4FF','border': '0.5px solid #DEE9F4'}
      default:return {'background-color':'#FFF9E0'}
      // CampaignTask
    }
  }
}